module.exports = __webpack_public_path__ + "static/media/duvidas-sobre-alugar-ou-comprar-imoveis.c2f1eb30.webp";